// file select
import FileSelect from './FileSelect'

if (!window.BS) window.BS = {}
window.BS.FileSelect = FileSelect
